<template>
  <div>
    <component :is="loginComponent" />
  </div>
</template>

<script>
import LoginAdmin from '@/components/Login/Login.vue'
import LoginClient from '@/components/Login/LoginClient.vue'
import LoginHospital from '@/components/Login/LoginHospital.vue'
import LoginMedico from '@/components/Login/LoginMedico.vue'
import LoginAgente from '@/components/Login/LoginAgent.vue'

export default {
  name: 'LoginView',
  computed: {
    loginComponent() {
      const routeName = this.$route.name
      console.log(routeName)
      switch (routeName) {
        case 'login-colaborador':
          return 'LoginAdmin'
        case 'login-cliente':
          return 'LoginClient'
        case 'login-hospital':
          return 'LoginHospital'
        case 'login-medico':
          return 'LoginMedico'
        case 'login-agente':
          return 'LoginAgente'
        default:
          return 'LoginClient' // fallback si entran por /login
      }
    }
  },
  components: {
    LoginAdmin,
    LoginClient,
    LoginHospital,
    LoginMedico,
    LoginAgente
  }
}
</script>
